import { signal } from '@preact/signals';
import { NativeAssets, RawNativeAssets, nativeAssetsParser } from '.';

export const nativeAssets = signal<NativeAssets>({});

export const setNativeAssets = (assets: RawNativeAssets) => {
  nativeAssets.value = nativeAssetsParser(assets);
};
